import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router } from "@angular/router";
import { NotifierService } from 'angular-notifier';

import swal from 'sweetalert2';
import * as jQuery from 'jquery';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { ValidationStrategyFactory } from 'src/app/strategy/validation-strategy.factory';
import { InstanceService } from 'src/app/service/instance.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { ProcessService } from 'src/app/service/process.service';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent extends ComponentBase implements OnInit, AfterViewInit {

  @Input() viewMode: OptionModel;
  @Output() executionRequest: EventEmitter<AttributeModel[]> = new EventEmitter();

  [x: string]: any;
  private notifier: NotifierService;

  public constructor(
    private router: Router,
    notifier: NotifierService,
    private instanceService: InstanceService,
    private processService: ProcessService,
    private spinner: NgxSpinnerService) {
      super()
      this.notifier = notifier;
  }

  stepCurrent: string;
  stringAttribute: string = sessionStorage.getItem("listAttribute");
  listAttribute: Array<string> = JSON.parse(sessionStorage.getItem("listAttribute"));
  policies: AttributeModel = JSON.parse(sessionStorage.getItem("policies"));
  eventEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }

  autoSave(isUpdate?: boolean) {
    if (this.isAutoSaving) {
      return;
    }

    let timeout = setTimeout(() => {
      this.spinner.show();
    }, 400);

    this.isAutoSaving = true;

    let isNew = this.processService.isNew
    this.processService.saveAttribute(this.attribute)
      .subscribe(() => {
        clearTimeout(timeout);

        if(isNew) {
          window.history.replaceState({}, '',
            '/processes/scope/view/' +
            sessionStorage.getItem('idPolicy') + '/' +
            sessionStorage.getItem('processId'))
        }

        this.updateDate = new Date()
        this.showNotification('default', 'Salvo');
        sessionStorage.setItem("returnTab", this.getKey(this.attribute.key));

        if(isUpdate) {
          this.emit({
            name: "save and update"
          })
        } else {
          this.spinner.hide();
        }

        this.isAutoSaving = false;
      }, (error)=> {
        clearTimeout(timeout);
        this.handleHttpError(error);
        this.isAutoSaving = false;
      })
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  public getKey(str: string): string {
    return str
      .trim()
      .split(" ")
      .join("_");
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }

  onGoListProcess() {
    this.router.navigateByUrl('/dashboard');
  }

  execute(events: DynamicEvent[]) {
    events.forEach(e => {
      if(e.name == "validate") {
        ValidationStrategyFactory.create(this.attribute).validate()
      } else if (e.name == "autosave" || e.name == "save and update") {
        this.autoSave(e.name == "save and update")
      } else if (e.name == "update") {
        this.emit({
          name: "update"
        })
      } else if (e.attribute && 
          (e.attribute.type.toLowerCase() == "task" ||
           e.attribute.type.toLowerCase() == "toggletask" ||
           e.attribute.type.toLowerCase().startsWith("action"))) {
        this.emitExecution(e);
      }
    })
  }

  private async emitExecution(e: DynamicEvent) {
    while (this.isAutoSaving) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    this.spinner.show();
    
    this.executionRequest.emit([e.attribute]);
  }

  selectStep(selectStep: string) {
    this.save();
    this.stepCurrent = selectStep;
    sessionStorage.setItem('stepCurrent', this.stepCurrent);
    $('.progress-bar').attr('style', 'width:' + this.getPercent() + '%');
    window.scrollTo(500, 0);
  }

  getIconClass(child: AttributeModel): string {
    if (!child.options)
      return null;

    let icon = child.options.find(option => option.key == 'Icon');

    if (icon)
      return icon.value;
  }

  visibilityStep(step: string): boolean {
    if (step != sessionStorage.getItem('stepCurrent')) {
      return true;
    }
    else {
      return false;
    }
  }

  getEnvOptions(): OptionModel[] {
    let viewModeOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "viewmode")

    if(viewModeOpt){
      let envViewModeOpt = this.envOptions
        .find(opt => opt.key.toLowerCase() == "viewmode")
      envViewModeOpt.value = viewModeOpt.value
    }

    return this.envOptions
  }

  getFields(): AttributeModel[] {
    return this.attribute.attributes
  }
}
